export const extractFinalUrl = (url: string): string => {
  const urlWithoutQuery = url?.split('?')[0];
  // Only remove leading '/' if present, otherwise use the URL as-is
  const urlToProcess = urlWithoutQuery?.startsWith('/')
    ? urlWithoutQuery.slice(1)
    : urlWithoutQuery;
  const segments = urlToProcess?.split('/');
  const lastSegment = segments[0] === 'tasks' ? 1 : 2;

  return segments
    .slice(0, lastSegment)
    .filter(segment => segment !== 'deal') // workaround for deal-book
    .join('/');
};
